import classNames from 'classnames';
import { CircularProgress, Typography } from '@material-ui/core';

import SearchRTIcon from '../../../assets/images/icons/searchRTIcon.webp';

import useStyles from './styles';

const CustomStateLabel = ({
  classes,
  Icon,
  onClick = () => {},
  stateMessage,
}) => {
  const componentClasses = useStyles();

  function DefaultIcon() {
    return (
      <div
        style={{ maxWidth: '2rem', maxHeight: '2rem', position: 'relative' }}
      >
        <img
          alt='status RT icon'
          src={SearchRTIcon}
          className={classNames(componentClasses.iconRoot, classes.iconRoot)}
        />
        <CircularProgress
          size='2rem'
          style={{ position: 'absolute', left: 0, top: 0 }}
        />
      </div>
    );
  }

  return (
    <div
      className={classNames(componentClasses.root, classes.root)}
      onClick={onClick}
    >
      {typeof Icon === 'string' && (
        <img
          alt='status RT icon'
          src={Icon}
          className={classNames(componentClasses.iconRoot, classes.iconRoot)}
        />
      )}
      {typeof Icon !== 'string' &&
        (Boolean(Icon) ? (
          <Icon
            classes={{
              root: classNames(componentClasses.iconRoot, classes.iconRoot),
            }}
          />
        ) : (
          <DefaultIcon />
        ))}
      {typeof stateMessage !== 'string' && stateMessage}
      {typeof stateMessage === 'string' && (
        <Typography
          className={classNames(componentClasses.message, classes.message)}
        >
          {stateMessage}
        </Typography>
      )}
    </div>
  );
};

CustomStateLabel.defaultProps = {
  classes: {},
  Icon: null,
  onClick: () => {},
  showLabel: true,
  stateMessage: '',
};

export default CustomStateLabel;
